import { Command } from 'ckeditor5';
import { v4 as uuid } from 'uuid';
/**
 * Inserts a placeholder at the selection and returns its instance id.
 *
 * Defaults to an unconfigured placeholder — an empty ref — so insertion never invents an identifier
 * that resolves to nothing. The caller opens its editor and lets the author pick a question.
 */
export class InsertPlaceholderCommand extends Command {
    execute(options = {}) {
        const { ref = '' } = options;
        const { model } = this.editor;
        const instanceId = uuid();
        model.change((writer) => {
            const placeholder = writer.createElement('placeholder', { id: ref, instanceId });
            model.insertObject(placeholder, model.document.selection, null, { setSelection: 'after' });
        });
        return instanceId;
    }
}
